var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogotipoMpDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 370,
    height: 187,
    viewBox: "0 0 370 187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logotipo-MP-dark",
    transform: "translate(-128.177 -375.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M128.177,562.093v-187h22.948L223.744,483.5H207.459l72.348-108.405h22.974v187h-35.79V453.166l7.475,2.108L230.948,519.9H199.98l-43.247-64.622,7.475-2.108V562.093Z",
    transform: "translate(0 0)",
    fill: "#00c16e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M314.846,402.919a57.006,57.006,0,0,0-23.223-20.572,73.154,73.154,0,0,0-32.84-7.253H181.365v35.079H250.51a28.823,28.823,0,0,1,12.678,2.77,21.747,21.747,0,0,1,9.213,8.441,26.094,26.094,0,0,1,3.469,13.845q0,8.182-3.469,13.718a22.036,22.036,0,0,1-9.213,8.31,28.817,28.817,0,0,1-12.678,2.766H181.249V495.1h.116v26.358h-.116v40.636h35.738V521.457h-.116V495.1h41.912a74.3,74.3,0,0,0,32.84-7.117,55.471,55.471,0,0,0,23.223-20.708q8.54-13.578,8.544-32.046Q323.39,416.242,314.846,402.919Z",
    transform: "translate(174.787 0)",
    fill: "#00c16e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(329.481 433.673)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 88.847,
    height: 35.079,
    transform: "translate(0 26.349)",
    fill: "#009153"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 35.506,
    height: 87.777,
    transform: "translate(26.67)",
    fill: "#009153"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotipoMpDark);
export default __webpack_public_path__ + "static/media/logotipo-MP-dark.9d03070461c8b746381c0321393d0167.svg";
export { ForwardRef as ReactComponent };